import React from 'react';
import TribalGenealogyForm from './TribalGenealogyForm';

const FamilyTreeForm = ({ onSubmit, loading, tribalMode = false }) => {
  // If in tribal mode, use the specialized tribal genealogy form
  if (tribalMode) {
    return <TribalGenealogyForm onSubmit={onSubmit} loading={loading} />;
  }
  
  // Otherwise return a simple fallback (or could be the original complex form)
  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <div className="text-center p-6 bg-blue-50 rounded-lg">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          Standard Family Tree Analysis
        </h3>
        <p className="text-gray-600">
          This is the standard family tree form option.
        </p>
      </div>
    </div>
  );
};

export default FamilyTreeForm;